import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "./style.css"; // Add your custom CSS here
import { useTranslation } from "react-i18next";

import wood from "assests/second-section/wood-bg-2.jpg";
import wood_ar from "assests/second-section/wood-bg-2-ar.jpg";
import lowWood from "assests/second-section/wood-bg-2-min.jpg";
import lowWood_ar from "assests/second-section/wood-bg-2-ar-min.jpg";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
import { CaretUp } from "@phosphor-icons/react";

gsap.registerPlugin(ScrollTrigger);

const Services = ({ data }) => {
  const component = useRef();
  const slider = useRef();
  const { i18n, t } = useTranslation();

  useLayoutEffect(() => {
    if (window.innerWidth > 992) {
      let ctx = gsap.context(() => {
        let panels = gsap.utils.toArray(".panel");
        const direction = i18n.language === "ar" ? 1 : -1;
        gsap.to(panels, {
          xPercent: direction * 100 * (panels.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: slider.current,
            pin: true,
            scrub: 0.0,
            snap: 0.5,
            end: "+=2000",
            onUpdate: (self) => {
              panels.forEach((panel, index) => {
                const progress = self.progress * (panels.length - 1);
                if (Math.round(progress) === index) {
                  panel.classList.add("active-panel");
                } else {
                  panel.classList.remove("active-panel");
                }
              });
            },
          },
        });
      }, component);

      return () => ctx.revert();
    }
  });

  const onImageLoad = (e) => {
    console.log(e);
  };

  return (
    <section
      className="hidden xl:block slider-parent bg-primary relative z-[0] pt-[80vh]"
      ref={component}
    >
      <div className="slider-container  relative bg-secondary " ref={slider}>
        {data?.slice(0, 3)?.map(({ text, title, image, slug }, index) => (
          <div
            key={index}
            style={{ backgroundImage: `url(${image})` }}
            className="flex h-[100vh]   items-center gap-x- panel-background about-panel panel "
          >
            {index === 0 && (
              <div className="absolute h-[100vh]  -top-[100vh] left-0 w-[100vw] z-[100]">
                <img
                  onLoad={onImageLoad}
                  src={`${i18n.language === "ar" ? wood_ar : wood}`}
                  alt=""
                  className="w-full  h-[115vh] "
                />
              </div>
            )}
            <Container>
              <div
                className={`w-1/2 h-[100vh] flex flex-col justify-center ${
                  i18n.language === "ar" ? "mr-20" : "ml-20"
                } px-10 content  ${index !== 0 ? "opacity-0" : ""}`}
              >
                <h6 className="titles-font text-3xl lg:text-4xl xx:text-5xl text-primary capitalize">
                  {title}
                </h6>
                <p className="mt-4 text-[#333] text-lg">{text}</p>

                <Link
                  to={`/serviceDetailes/${slug}`}
                  className="flex font-bold mt-4 items-center  gap-x-2 text-sm"
                >
                  <CaretUp size={28} weight="fill" />
                  {t("learn_more")}
                </Link>
              </div>
            </Container>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
